<template>
    <div>
        <v-card
            v-if="isLoading && contracts.length < 1"
            class="pa-md-2 mt-md-n3"
            elevation="0"
            width="100%"
        >
            <LoadingSkeleton />
        </v-card>
        <v-card elevation="0" class="pa-0">
            <div
                style="font-size: 3em;"
                v-if="contracts.length < 1"
            >
                <div v-if="!isLoadingDetailed">
                    <div
                        class="
                            d-flex
                            justify-center
                            display-1
                            grey--text
                            text-center
                        "
                    >
                        Contratos No Cargados
                    </div>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div class="d-flex justify-center">
                                <v-icon
                                    @click="getContract()"
                                    color="primary"
                                    size="60"
                                    v-bind="attrs"
                                    v-on="on"
                                    >mdi-download-outline
                                </v-icon>
                            </div>
                        </template>
                        <span>
                            Consultar
                            <v-icon color="white">mdi-magnify</v-icon>
                        </span>
                    </v-tooltip>
                </div>
                <div class="d-flex justify-center" v-else>
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        class="ma-2"
                        size="80"
                    ></v-progress-circular>
                </div>
            </div>
            <v-expansion-panels v-else v-model="panel" multiple flat>
                <v-expansion-panel
                    v-for="(item, index) in contracts"
                    :key="index"
                >
                    <v-expansion-panel-header
                        disable-icon-rotate
                        ripple
                        color="grey lighten-3"
                    >
                        <template v-slot:actions>
                            <h3
                                class="
                                    d-flex
                                    align-self-center
                                    font-weight-regular
                                    mr-1
                                "
                            >
                                Paquetes
                            </h3>
                            <v-icon color="primary">
                                {{
                                    'mdi-numeric-' +
                                    item.paquetes.length +
                                    '-circle-outline'
                                }}
                            </v-icon>
                        </template>
                        <h2 class="d-flex align-self-center font-weight-light">
                            Contrato {{ index + 1 }}
                        </h2>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-expansion-panels flat>
                            <v-expansion-panel
                                v-for="(paquete, i) in item.paquetes"
                                :key="i"
                            >
                                <v-expansion-panel-header disable-icon-rotate>
                                    <h4
                                        class="
                                            d-flex
                                            align-self-center align-center
                                            font-weight-light
                                        "
                                    >
                                        <v-tooltip bottom>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    color="primary"
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="mr-2"
                                                >
                                                    {{
                                                        iconsByLine[
                                                            paquete.tipoLinea
                                                        ]
                                                    }}
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{
                                                    paquete.tipoLinea.replaceAll(
                                                        '_',
                                                        ' '
                                                    )
                                                }}</span
                                            >
                                        </v-tooltip>
                                        <strong>{{
                                            paquete.lineasAsociadas.join(', ')
                                        }}</strong>
                                    </h4>
                                    <template v-slot:actions>
                                        <v-tooltip bottom>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    v-if="
                                                        paquete.additionalinfo
                                                    "
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    small
                                                    :color="
                                                        statePackage[
                                                            paquete
                                                                .additionalinfo
                                                                .state
                                                        ]['color']
                                                    "
                                                    class="mb-2"
                                                >
                                                    <small>{{
                                                        paquete.additionalinfo
                                                            .state
                                                    }}</small>
                                                    <v-icon
                                                        :color="
                                                            statePackage[
                                                                paquete
                                                                    .additionalinfo
                                                                    .state
                                                            ]['color']
                                                        "
                                                        right
                                                        >{{
                                                            `mdi-${
                                                                statePackage[
                                                                    paquete
                                                                        .additionalinfo
                                                                        .state
                                                                ]['icon']
                                                            }`
                                                        }}</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>
                                                <div>
                                                    {{
                                                        paquete.additionalinfo &&
                                                        paquete.additionalinfo
                                                            .orderId
                                                            ? `Id de orden: ${paquete.additionalinfo.orderId}`
                                                            : ''
                                                    }}
                                                </div>
                                                <div>
                                                    {{
                                                        paquete.additionalinfo &&
                                                        paquete.additionalinfo
                                                            .sfid
                                                            ? `SDIF: ${paquete.additionalinfo.sfid}`
                                                            : ''
                                                    }}
                                                </div>
                                            </span>
                                        </v-tooltip>
                                    </template>
                                </v-expansion-panel-header>
                                <v-divider class="mt-n4 mx-5 mb-6"></v-divider>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col cols="5">
                                            <h4
                                                class="
                                                    d-flex
                                                    align-self-center
                                                    font-weight-bold
                                                "
                                            >
                                                Tarifa:
                                            </h4>
                                            <h4
                                                class="
                                                    d-flex
                                                    align-self-center
                                                    font-weight-thin
                                                "
                                            >
                                                {{ paquete.tarifa.name }}
                                            </h4>
                                        </v-col>
                                        <v-col cols="7">
                                            <h4
                                                class="
                                                    d-flex
                                                    align-self-center
                                                    font-weight-bold
                                                "
                                            >
                                                Precio:
                                            </h4>
                                            <h4
                                                class="
                                                    d-flex
                                                    align-self-center
                                                    font-weight-thin
                                                "
                                            >
                                                {{
                                                    parseToFloatSpecialInteger(
                                                        paquete.servicePrice
                                                            .price *
                                                            ((1 +
                                                                item.tipoIva) /
                                                                100)
                                                    )
                                                }}
                                                €
                                            </h4>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="paquete.cacharro">
                                        <v-col cols="5">
                                            <h4
                                                class="
                                                    d-flex
                                                    align-self-center
                                                    font-weight-bold
                                                "
                                            >
                                                Dispositivo:
                                            </h4>
                                            <h4
                                                class="
                                                    d-flex
                                                    align-self-center
                                                    font-weight-thin
                                                "
                                            >
                                                {{ paquete.cacharro.name }}
                                            </h4>
                                        </v-col>
                                        <v-col cols="7">
                                            <v-row>
                                                <v-col>
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-bold
                                                        "
                                                    >
                                                        Precio:
                                                    </h4>
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-thin
                                                        "
                                                    >
                                                        {{
                                                            paquete.cacharro
                                                                .price
                                                                ? parseToFloatSpecialInteger(
                                                                      paquete
                                                                          .cacharro
                                                                          .price
                                                                  )
                                                                : 'N/A'
                                                        }}
                                                        €
                                                    </h4>
                                                </v-col>
                                                <v-col>
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-bold
                                                        "
                                                    >
                                                        Seguro:
                                                    </h4>
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-thin
                                                        "
                                                    >
                                                        {{
                                                            paquete.seguro
                                                                ? (
                                                                      paquete
                                                                          .seguro
                                                                          .price *
                                                                      ((1 +
                                                                          item.tipoIva) /
                                                                          100)
                                                                  ).toFixed(2)
                                                                : 'N/A'
                                                        }}
                                                        €
                                                    </h4>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        class="px-3 mt-7"
                                        v-if="paquete.promotion.length"
                                    >
                                        <h4
                                            class="
                                                d-flex
                                                align-self-center
                                                font-weight-bold
                                            "
                                        >
                                            Promociones:
                                        </h4>
                                    </v-row>
                                    <v-row
                                        class="px-3 mt-5"
                                        v-if="paquete.promotion.length"
                                    >
                                        <v-col
                                            v-for="promo in paquete.promotion"
                                            :key="promo.id"
                                            cols="3"
                                            class="px-5"
                                        >
                                            <v-row no-gutters>
                                                <h4 class="font-weight-bold">
                                                    {{ promo.name }}
                                                </h4>
                                            </v-row>
                                            <v-divider></v-divider>
                                            <v-row
                                                class="pt-3 d-flex"
                                                no-guters
                                            >
                                                <v-col cols="7">
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-light
                                                        "
                                                    >
                                                        Duración:
                                                    </h4>
                                                </v-col>
                                                <v-col
                                                    cols="5"
                                                    class="
                                                        d-flex
                                                        justify-space-between
                                                    "
                                                >
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-thin
                                                        "
                                                    >
                                                        {{
                                                            promo.duration == 0
                                                                ? 'Para siempre'
                                                                : promo.duration
                                                        }}
                                                    </h4>
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-thin
                                                        "
                                                    >
                                                        {{
                                                            promo.durationUnit ==
                                                                'month' &&
                                                            promo.duration != 0
                                                                ? 'meses'
                                                                : ''
                                                        }}
                                                    </h4>
                                                </v-col>
                                            </v-row>
                                            <v-row
                                                class="mt-n6 d-flex"
                                                no-guters
                                            >
                                                <v-col cols="8">
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-light
                                                        "
                                                    >
                                                        Cantidad:
                                                    </h4>
                                                </v-col>
                                                <v-col
                                                    cols="4"
                                                    class="
                                                        d-flex
                                                        justify-space-between
                                                    "
                                                >
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-thin
                                                        "
                                                    >
                                                        {{
                                                            parseToFloatSpecialInteger(
                                                                promo.amount
                                                            )
                                                        }}
                                                    </h4>
                                                    <h4
                                                        class="
                                                            d-flex
                                                            align-self-center
                                                            font-weight-thin
                                                        "
                                                    >
                                                        {{
                                                            promo.amountUnit ==
                                                            'PERCENTS'
                                                                ? ' %'
                                                                : ' €'
                                                        }}
                                                    </h4>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        class="px-3 mt-7"
                                        v-if="
                                            paquete.additionalinfo &&
                                            paquete.additionalinfo.permanences
                                                .length
                                        "
                                    >
                                        <h4
                                            class="
                                                d-flex
                                                align-self-center
                                                font-weight-bold
                                            "
                                        >
                                            Permanencias:
                                        </h4>
                                    </v-row>
                                    <v-row v-if="paquete.additionalinfo">
                                        <v-col
                                            class="px-8"
                                            v-for="permanence in paquete
                                                .additionalinfo.permanences"
                                            :key="permanence.id"
                                            cols="3"
                                        >
                                            <h4 class="font-weight-bold">
                                                {{ permanence.permanenceCode }}
                                            </h4>
                                            <v-divider></v-divider>
                                            <div
                                                class="
                                                    d-flex
                                                    justify-space-between
                                                "
                                            >
                                                <h4 class="font-weight-light">
                                                    Inicio:
                                                </h4>
                                                <h4 class="font-weight-thin">
                                                    {{
                                                        formatDate(
                                                            permanence.begin
                                                        )
                                                    }}
                                                </h4>
                                            </div>
                                            <div
                                                class="
                                                    d-flex
                                                    justify-space-between
                                                "
                                            >
                                                <h4 class="font-weight-light">
                                                    Fin:
                                                </h4>
                                                <h4 class="font-weight-thin">
                                                    {{
                                                        formatDate(
                                                            permanence.end
                                                        )
                                                    }}
                                                </h4>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <!-- <v-card-actions class="d-flex justify-end">
                <v-btn
                    text
                    color="orange"
                    @click="getContract()"
                    :disabled="isLoadingDetailed"
                >
                    Actualizar
                </v-btn>
            </v-card-actions> -->
        </v-card>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';
import { formatDate, parseToFloatSpecialInteger } from '@/util/libUtil.js';

export default {
    name: 'LogContracts',
    components: {
        LoadingSkeleton,
    },
    data: () => ({
        iconsByLine: {
            LINEA_PRINCIPAL: 'mdi-phone',
            LINEA_ADICIONAL: 'mdi-phone-plus',
            LINEA_ADICIONAL_SVA: 'mdi-basket-plus',
        },
        panel: [0],
    }),
    computed: {
        ...mapState('teletrabajo', {
            detailedForm: (state) => state.CompleteViewTtForm.details.form,
            contracts: (state) => state.CompleteViewTtForm.contracts,
            isLoading: (state) => state.CompleteViewTtForm.isLoadingContracts,
            clienteId: (state) => state.TtForm.id,
            isLoadingDetailed: (state) =>
                state.CompleteViewTtForm.details.isLoading,
        }),
        ...mapState('orders', {
            statePackage: (state) => state.statePackage,
        }),
    },
    methods: {
        formatDate,
        parseToFloatSpecialInteger,
        sortPackages(packages) {
            return packages
                .sort((a, b) => {
                    if (a.tipoLinea < b.tipoLinea) {
                        return -1;
                    }
                    if (a.tipoLinea > b.tipoLinea) {
                        return 1;
                    }
                    return 0;
                })
                .reverse();
        },
        getContract() {
            // this.fetchTtClienteDetailed({
            //     idTtCliente: this.clienteId,
            // }).then(() => {
            //     this.fetchTtClienteContracts(this.clienteId);
            //     if (this.detailedForm.IS_UPDATE) {
            //         this.$store.dispatch('teletrabajo/getTableData');
            //     }
            // });
        },
        ...mapActions({
            fetchTtClienteDetailed: 'teletrabajo/fetchTtClienteDetailed',
            fetchTtClienteContracts: 'teletrabajo/fetchTtClienteContracts',
        }),
    },
    watch: {
        contracts: {
            immediate: true,
            handler(newValue) {
                newValue.forEach((contract) => {
                    contract.paquetes = this.sortPackages(contract.paquetes);
                });
            },
        },
    },
};
</script>